import { render } from "./Submissions.vue?vue&type=template&id=d3920ff0&scoped=true"
import script from "./Submissions.vue?vue&type=script&lang=js"
export * from "./Submissions.vue?vue&type=script&lang=js"

import "./Submissions.vue?vue&type=style&index=0&id=d3920ff0&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3920ff0"]])

export default __exports__